/* Zijwinkelwagen (16-10-2026): vangt elk formulier naar /cart/add af, werkt de winkelwagen bij via de
   Ajax Cart API en ververst sections/pph-cart-drawer.liquid via de Section Rendering API.
   Zonder JavaScript blijft alles werken via /cart. */
(function () {
  var cd = document.getElementById('pph-cd');
  if (!cd || !window.fetch) return;
  var SEC = 'pph-cart-drawer';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var panel = cd.querySelector('.pph-cd__panel');
  var live = document.getElementById('pph-cd-live');
  var lastFocus = null, closeTimer = null;

  function inner() { return document.getElementById('pph-cd-inner'); }

  function open() {
    clearTimeout(closeTimer);
    if (cd.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    document.documentElement.style.setProperty('--pph-sbw', (window.innerWidth - document.documentElement.clientWidth) + 'px');
    cd.inert = false;
    document.documentElement.classList.add('pph-cd-lock');
    cd.getBoundingClientRect();   // reflow, zodat de schuifanimatie start vanuit de gesloten stand
    cd.classList.add('is-open');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    if (!cd.classList.contains('is-open')) return;
    cd.classList.remove('is-open');
    closeTimer = setTimeout(function () {
      cd.inert = true;
      document.documentElement.classList.remove('pph-cd-lock');
    }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function setCount(n) {
    var a = document.getElementById('pph-hdr-cart');
    if (!a) return;
    var b = a.querySelector('.pph-hdr__count');
    if (n > 0) {
      if (!b) { b = document.createElement('span'); b.className = 'pph-hdr__count'; a.appendChild(b); }
      b.textContent = n;
    } else if (b) b.remove();
  }

  function render(html, newKey) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('pph-cd-inner'), cur = inner();
    if (!fresh || !cur) return;
    var oldBar = cur.querySelector('.pph-cd__bar span');
    var from = oldBar ? oldBar.style.width : '0%';
    var code = cur.querySelector('#pph-cd-code');
    var codeVal = code && document.activeElement === code ? code.value : '';
    var foc = focusables(cur), fi = foc.indexOf(document.activeElement);
    cur.replaceWith(fresh);
    if (fi > -1) { var nf = focusables(fresh); (nf[Math.min(fi, nf.length - 1)] || panel).focus({ preventScroll: true }); }
    var bar = fresh.querySelector('.pph-cd__bar span');
    if (bar) {
      bar.style.width = from; bar.getBoundingClientRect();
      bar.style.width = bar.getAttribute('data-w') + '%';
    }
    if (codeVal) { var c2 = fresh.querySelector('#pph-cd-code'); if (c2) c2.value = codeVal; }
    if (newKey) {
      var li = fresh.querySelector('.pph-cd__it[data-key="' + newKey.replace(/"/g, '') + '"]');
      if (li) li.classList.add('is-new');
    }
    setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
    if (live) { live.textContent = ''; setTimeout(function () { live.textContent = cd.getAttribute('data-t-updated'); }, 30); }
  }

  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
  }
  function codeMsg(t) {
    var m = document.getElementById('pph-cd-codemsg');
    if (m) m.textContent = t || '';
  }
  function busy(on) { cd.classList.toggle('is-busy', on); panel.setAttribute('aria-busy', on ? 'true' : 'false'); }

  function post(path, body) {
    var isForm = body instanceof FormData;
    if (isForm) body.append('sections', SEC); else body.sections = SEC;
    return fetch(root + path, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
                      : { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) { var e = new Error(j.description || j.message || ''); e.data = j; throw e; }
        return j;
      });
    });
  }
  function refresh() {
    return fetch(root + '?sections=' + SEC, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[SEC]); })
      .catch(function () {});
  }
  function fail(err) {
    var msg = (err && err.message) || cd.getAttribute('data-t-error');
    return refresh().then(function () { codeMsg(''); showTop(msg); });
  }
  function showTop(msg) {
    var cur = inner(); if (!cur) return;
    var p = cur.querySelector('.pph-cd__err');
    if (!p) { p = document.createElement('p'); p.className = 'pph-cd__err'; p.setAttribute('role', 'alert'); cur.querySelector('.pph-cd__head').after(p); }
    p.textContent = msg;
  }

  // Toevoegen: elk productformulier (productpagina, sticky balk, kaarten)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !(f instanceof HTMLFormElement)) return;
    var a = f.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(a)) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type=submit]');
    var sticky = document.getElementById('pph-satc-btn');
    [btn, f.id === 'pph-form' ? sticky : null].forEach(function (b) { if (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); } });
    var done = function () { [btn, sticky].forEach(function (b) { if (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); } }); };
    post('cart/add.js', new FormData(f))
      .then(function (j) { render(j.sections && j.sections[SEC], j.key); codeMsg(''); open(); })
      .catch(function (err) { return fail(err).then(open); })
      .then(done, done);
  });

  // Openen via het winkelwagenicoon
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#pph-hdr-cart');
    if (t && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); open(); refresh(); return; }
    if (!cd.contains(e.target)) return;
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var q = e.target.closest('[data-cd-qty]');
    if (q && !q.disabled) {
      var li = q.closest('[data-key]');
      busy(true);
      post('cart/change.js', { id: li.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-cd-qty'), 10) })
        .then(function (j) { render(j.sections && j.sections[SEC]); })
        .catch(fail)
        .then(function () { busy(false); });
      return;
    }
    var rc = e.target.closest('[data-cd-rmcode]');
    if (rc) {
      var rm = rc.getAttribute('data-cd-rmcode').toLowerCase();
      var keep = codes().filter(function (c) { return c.toLowerCase() !== rm; });
      busy(true);
      post('cart/update.js', { discount: keep.join(',') })
        .then(function (j) { render(j.sections && j.sections[SEC]); codeMsg(''); })
        .catch(fail)
        .then(function () { busy(false); });
    }
  });

  function codes() {
    var c = inner() && inner().getAttribute('data-codes');
    return c ? c.split(',').filter(Boolean) : [];
  }

  // Kortingscode toepassen
  cd.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-cd-code]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('input'), code = input.value.trim();
    if (!code) { input.focus(); return; }
    var prev = codes();
    var lc = code.toLowerCase();
    if (prev.some(function (c) { return c.toLowerCase() === lc; })) { input.value = ''; return; }
    busy(true); codeMsg('');
    post('cart/update.js', { discount: prev.concat(code).join(',') })
      .then(function (j) {
        var hit = (j.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === lc; })[0];
        if (hit && hit.applicable) { render(j.sections && j.sections[SEC]); return; }
        // ongeldig of niet van toepassing: code weer uit de winkelwagen halen
        return post('cart/update.js', { discount: prev.join(',') }).then(function (j2) {
          render(j2.sections && j2.sections[SEC]);
          var i2 = inner().querySelector('#pph-cd-code'); if (i2) { i2.value = code; i2.focus(); }
          codeMsg(cd.getAttribute('data-t-invalid'));
        });
      })
      .catch(fail)
      .then(function () { busy(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (!cd.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var els = focusables(panel);
    if (!els.length) return;
    var first = els[0], last = els[els.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Terug naar de pagina via de browsercache: winkelwagen kan intussen veranderd zijn
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.pphCart = { open: open, close: close, refresh: refresh };
})();
